import React, { Component } from "react";

export default class Content extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div className="content_s" id="scrollBox">
            <div className="newHeadTitle">{this.props.data.name}</div>
            <div className="newPreamble">
                <div className="title page_title">{this.props.data.preamble.title}</div>
                <div className="time">{this.props.data.time}</div>
            </div>
            <div className="content newContent">
                {this.props.data.preamble.wordlist.map((word, i) => <div key={i}>{word}</div>)}
            </div>
            {this.props.data.mainWords.map((word, i) => <div key={i+'_list'}>
                <div className="title wei_bo_title">{word.title}</div>
                <div className="content newContent">{word.wordlist.map((wd, j) => <div key={j+'__j_'}>{wd}</div>)}</div>
            </div>)}
            <div className="signature newSignature">{this.props.data.company}</div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/component/newEra/Content.js